import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import "./Header-v2.css"; // Styles for this V2 header

// Assets from the original V2 header design
import logo from '../assets/images/onetime-logo-updated-1-v3.png';
import twitterIcon from '../assets/images/fa-brands_twitter.svg';
import discordIcon from '../assets/images/fa-brands_discord.svg';
import telegramIcon from '../assets/images/fa-brands_telegram-plane.svg';
import vectorStroke from '../assets/images/Vector-Stroke.svg'; // For hamburger icon

import { useAuth } from "../context/AuthContext"; // Corrected path

function HeaderV2() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const navigate = useNavigate();
  const { isAuthenticated, isLoading, logout } = useAuth(); // username not used in this design

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const handleMenuItemClick = () => {
    if (isMenuOpen) {
      setIsMenuOpen(false);
    }
  };

  const handleLogout = () => {
    logout();
    handleMenuItemClick();
    navigate('/login');
  };

  const handleLoginRedirect = () => {
    const currentPath = window.location.pathname;
    localStorage.setItem("redirectAfterLogin", 
      (currentPath === "/signup" || currentPath === "/login") ? "/contests" : currentPath
    );
    navigate("/login");
    handleMenuItemClick();
  };

  const handleLogoClick = () => {
    setIsMenuOpen(false);
  };

  // No specific loading state design provided for this header, 
  // so we'll render the full header. It might flash if auth state changes quickly.
  // if (isLoading) { return <header className="homev2-header"></header>; } 

  return (
    <header className="homev2-header">
      <div className="homev2-header__topbar-bar">
        <a href="https://twitter.com" target="_blank" rel="noopener noreferrer">
          <img src={twitterIcon} alt="Twitter" />
        </a>
        <a href="https://discord.com" target="_blank" rel="noopener noreferrer">
          <img src={discordIcon} alt="Discord" />
        </a>
        <a href="https://t.me/+MbCZNnqMWjlhZjkx" target="_blank" rel="noopener noreferrer">
          <img src={telegramIcon} alt="Telegram" />
        </a>
      </div>

      <div className="homev2-header__main">
        <Link to="/" onClick={handleLogoClick} className="homev2-header__logo-link">
          <img src={logo} alt="One-Time Fantasy Logo" className="homev2-header__logo" />
        </Link>
        
        <nav className={`homev2-header__menu-group ${isMenuOpen ? "open" : ""}`}>
          <div className="homev2-header__nav">
            <Link to="/" onClick={handleMenuItemClick}>Home</Link>
            <Link to="/contests" onClick={handleMenuItemClick}>Contests</Link>
            <Link to="/rules" onClick={handleMenuItemClick}>Rules</Link>
            {isAuthenticated ? (
              <Link to="/account" onClick={handleMenuItemClick}>Account</Link>
            ) : (
              <>
                <Link to="/login" onClick={handleLoginRedirect}>Login</Link>
                <Link to="/signup" onClick={handleMenuItemClick}>Sign Up</Link>
              </>
            )}
          </div>

          <ul className="homev2-header__mobile-list">
            <li><Link to="/" onClick={handleMenuItemClick}>Home</Link></li>
            <li><Link to="/contests" onClick={handleMenuItemClick}>Contests</Link></li>
            <li><Link to="/rules" onClick={handleMenuItemClick}>Rules</Link></li>
            {isAuthenticated ? (
              <>
                <li><Link to="/account" onClick={handleMenuItemClick}>Account</Link></li>
                <li><button onClick={handleLogout} className="logout-button-link">Logout</button></li>
              </>
            ) : (
              <>
                <li><Link to="/login" onClick={handleLoginRedirect}>Login</Link></li>
                <li><Link to="/signup" onClick={handleMenuItemClick}>Sign Up</Link></li>
              </>
            )}
          </ul>
        </nav>

        <button 
          className="homev2-header__hamburger" 
          aria-label="Open menu" 
          aria-expanded={isMenuOpen}
          onClick={toggleMenu}
        >
          <img src={vectorStroke} alt="" />
          <img src={vectorStroke} alt="" />
          <img src={vectorStroke} alt="" />
        </button>
      </div>
    </header>
  );
}

export default HeaderV2;
